module.exports = __webpack_public_path__ + "media/assets/icons/quill/bold-039369337e1b230d8be4ccd9b6724d44.svg";